
import DataMapper from '../DataMapper'
import InsuredModel from '../../../models/ReportModels/InsuredModel'
import InsuredRM from '../../responsemodel/ReportRM/InsuredRM'
export default class InsuredDataMapper extends DataMapper<InsuredRM, InsuredModel> {
    map = (rm: InsuredRM) => new InsuredModel(rm._id, rm.name, rm.mobile, rm.dob)
}
